export enum Permission {
    MODULE_SUPPORT = "MODULE_SUPPORT",
    MODULE_COMPANY = 'MODULE_COMPANY',
    MODULE_SUPPORT_REQUEST_EDIT = "MODULE_SUPPORT_REQUEST_EDIT",
    REQUEST_RESEND = "REQUEST_RESEND",
    REQUEST_EDIT_JSON = "REQUEST_EDIT_JSON",
    CATALOG_VIEW = 'CATALOG_VIEW',
    MARKETPLACE_CATALOG_VIEW = 'MARKETPLACE_CATALOG_VIEW'
}